import router from './router'
import useStaticSitemapEntriesStore from './store'
import StaticSitemapEntriesMessages from './localization'

export default {
  router,
  useStaticSitemapEntriesStore,
  localization: StaticSitemapEntriesMessages,
}
